import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "change-main-address",
    data() {
        return {
            payload: {
                active: null,
                city: null,
                flat: null,
                house: null,
                id: null,
                street: null,
            },
        };
    },
    computed: {
        ...mapGetters({
            changeAddressData: `profile/openPopUpAddressChange`,
            user: "profile/user",
        }),
        findCurrentAddress() {
            for (let i in this.user.addresses) {
                if (this.user.addresses[i].id === this.changeAddressData.id) {
                    return this.user.addresses[i];
                }
            }
        },
    },
    methods: {
        ...mapActions({
            addUserAddress: `profile/ADD_USER_ADDRESS`,
            editUserAddress: `profile/EDIT_USER_ADDRESS`,
            fetchUserData: `profile/FETCH_USER_DATA`,
        }),
        ...mapMutations({
            changePopupMainAddress: `profile/CHANGE_POPUP_MAIN_ADDRESS`,
        }),
        submit() {
            for (let i in this.user.addresses) {
                if (this.user.addresses[i].id === this.changeAddressData.id) {
                    this.payload.city = this.user.addresses[i].city;
                    this.payload.flat = this.user.addresses[i].flat;
                    this.payload.house = this.user.addresses[i].house;
                    this.payload.id = this.user.addresses[i].id;
                    this.payload.street = this.user.addresses[i].street;
                    this.payload.active = 1;
                    // console.log(this.payload)
                    this.editUserAddress(this.payload)
                        .then(() => {
                            this.$toasted.success(this.$t("youAddressRefresh"));
                            this.fetchUserData();
                            this.changePopupMainAddress({ show: false });
                            // this.showLoader = false;
                            // this.isEdit = true;
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                console.log(error.response);
                                // this.showLoader = false;
                                // this.isEdit = true;
                            }
                        });
                }
            }
            // this.findCurrentAddress
            // console.log(this.findCurrentAddress);
        },
    },
    created() {
        // console.log(this.changeAddressData);
        // console.log(this.user)
    },
};
